export default __webpack_public_path__ + "static/media/g2022-27.74dd3939.jpeg";